import { PatientService } from 'src/app/shared/services/patient/patient-info.service';
import { Injectable, computed, signal } from '@angular/core';
import { MedicalRecordState } from '../store/medical-record.state';
import { Store } from '@ngrx/store';
import { getAuthStateSelect } from 'src/app/core/store/auth/auth.selector';
import { Subscription, firstValueFrom, BehaviorSubject } from 'rxjs';
import { IUser, } from 'src/app/core/models/user.model';
import { QuestionaryNames, QuestionnaireResponse } from '../model/questionnaire-response';
import { QuestionnairesService } from './questionnaires.service';
import { deepCloning } from 'src/app/shared/utils/functions';
import {
  clearAllMedicalRecord,
  clearAnamnesisQuestionnaireResponse,
  clearConductQuestionnaireResponse,
  clearEvolutionQuestionnaireResponse,
  clearNursingAvaliation,
  clearNursingDiagnosis,
  clearNursingHistory,
  clearNutritionQuestionnaireResponse,
  clearPharmacyAttentionQuestionnaireResponse,
  clearPharmacyInterventionQuestionnaireResponse,
  clearPhysicalExamQuestionnaireResponse,
  clearRamQuestionnaireResponse,
  clearToxicityQuestionnaireResponse,
  clearVitalSignsQuestionnaireResponse,
  setAnamnesisQuestionnaireResponse,
  setChemotherapy,
  setConductQuestionnaireResponse,
  updateTodayConduct,
  setEducationQuestionnaireResponse,
  setEvolutionQuestionnaireResponse,
  setNursingAvaliation,
  setNursingDiagnosis,
  setNursingHistory,
  setNutritionQuestionnaireResponse,
  setPharmacyAttention,
  setPharmacyIntervention,
  setPhysicalExamQuestionnaireResponse,
  setRamQuestionnaireResponse,
  setSolicitations,
  setToxicityQuestionnaireResponse,
  setVitalSignsQuestionnaireResponse,
  updateTodayAnamnesisQuestionnaireResponse,
  updateTodayEvolutionQuestionnaireResponse,
  updateTodayNursingAvaliation,
  updateTodayNursingDiagnosis,
  updateTodayNursingHistory,
  updateTodayNutritionQuestionnaireResponse,
  updateTodayPharmacyAttention,
  updateTodayPhysicalExamQuestionnaireResponse,
  updateTodayRamQuestionnaireResponse,
  updateTodayToxicityQuestionnaireResponse,
  updateTodayVitalSignsQuestionnaireResponse,
  setNursing,
  setPsychology,
  setPharmacy,
  clearPsychology
} from '../store/medical-record.action';
import { ExamsOrdersService } from './exams-orders.service';
import { ChemotherapyService } from './chemotherapy.service';
import { getMedicalRecordState } from '../store/medical-record.selector';
import { toSignal } from '@angular/core/rxjs-interop';
import { PharmacyAttention } from '../medical-record-page/pages/pharmacy/models/pharmacy-attention.model';
import { PharmacyIntervention } from '../medical-record-page/pages/pharmacy/models/pharmacy-intervation.model';
import { updateTodayPharmacyIntervention } from './../store/medical-record.action';
import { DiagnosticService } from '../medical-record-page/pages/diagnostic/service/diagnostic.service';
import { NursingAssessment } from './../medical-record-page/pages/nursing/model/nursing-assessment.model';
import { NursingDiagnosis } from './../medical-record-page/pages/nursing/model/nursing-diagnosis.model';
import { NursingHistory } from '../medical-record-page/pages/nursing/model/nursing-history.model';
import { abreviateFullName } from 'src/app/shared/utils/string.utils';
import { PsychologyService } from './psychology.service';
import { NursingService } from './nursing.service';
import { PharmacyService } from './pharmacy.service';
import { EvolutionService } from './evolution.service';
import { PhysicalExamService } from './physical-exam.service';
import { ConductService } from './conduct.service';
import { NutritionService } from './nutrition.service';
import { RamService } from './ram.service';
import { AllergiesCommorbiditiesService } from './allergies-commorbidities.service';
import { AnamnesisService } from './anamnesis.service';


export type PermissionType = {
  read: boolean,
  write: boolean
}

type MedicalRecordLoadingState = Partial<{
  questionaries: boolean,
  chemotherapy: boolean,
  solicitation: boolean,
  diagnoses: boolean,
}>

@Injectable({
  providedIn: 'root'
})

export class MedicalRecordService {

  private loadingMedcialRecordState = signal<MedicalRecordLoadingState>({});
  private _isMedicalRecordOpen = new BehaviorSubject(false)
  // private _loadingMedicalRecords = new BehaviorSubject<boolean>(false);
  // private selectedTab = new BehaviorSubject<MedicalTab>(this.defaultTab);

  userLogged: IUser | null = null;
  subscription: Subscription = new Subscription();
  patientSelectedId: string = '';
  patientSelectedName: string = '';
  tabsName: Array<string> = ['anamnesis', 'evolution', 'diagnosis', 'vitalSigns', 'physicalExam', 'conduct', 'solicitations', 'toxicity', 'education', 'chemotherapy', 'ram', 'nutrition'];

  constructor(
    private store: Store<MedicalRecordState>,
    private questionnaireService: QuestionnairesService,
    private patientInfoService: PatientService,
    private chemotherapyService: ChemotherapyService,
    private solicitationService: ExamsOrdersService,
    private diagnosticService: DiagnosticService,
    private psychologyService: PsychologyService,
    private nursingService: NursingService,
    private pharmacyService: PharmacyService,
    private evolutionService: EvolutionService,
    private anamnesisService: AnamnesisService,
    private physicalExamService: PhysicalExamService,
    private conductService: ConductService,
    private nutritionService: NutritionService,
    private ramService: RamService,
    private allergiesComorbsService: AllergiesCommorbiditiesService

  ) {

    // todo: achar maneira melhor de fazer isso! atualmente se algum componente usar esse serviço (ou um serviço que usa esse, etc),
    // já vai começar a
    // se inscrever e mudar paciente. Da maneira que está é muito dificil saber quem muda quem. Def de código macarrao.
    // subscreve para reagir a mudança de paciente selecionado
    // e fazer as devidas operacoes (apagar da memoria pronturarios e pegar os dados medicos do novo
    // paciente selecionado)
    this.subscription.add(this.patientInfoService.getPatientId()
      .subscribe((patientId) => {
        if (patientId && this.patientSelectedId !== patientId) {
          this.patientSelectedId = patientId;
        }
      }));

    this.subscription.add(this.store.select(getAuthStateSelect)
      .subscribe((user) => {
        this.userLogged = deepCloning(user.user);
      }));

    this.subscription.add(
      this.patientInfoService
        .getSelectedPatient()
        .subscribe((patient) => {
          if (patient && this.patientSelectedId !== patient.patientId) {
            this.patientSelectedName = patient.patientName;
          }
        }));
  }

  async nonQuestionariesMRtoSave() {
    const questionaries = await firstValueFrom(this.store.select(getMedicalRecordState))
    const quimioToSave = (questionaries.chemotherapyPage?.chemotherapy ?? []).filter(c => c._changed)
    const quimioToUpdate = (questionaries.chemotherapyPage?.chemotherapy ?? []).filter(c => !c._changed && c._actions)
    const quimioToDelete = (questionaries.chemotherapyPage?.chemoToDelete ?? []).filter(c => c.chemotherapyId);

    const diagToSave = (questionaries.diagnoses ?? []).filter(c => c._toSave)
    const diagToUpdate = (questionaries.diagnoses ?? []).filter(c => !c._toSave && c._toUpdate)
    return {
      quimioToUpdate,
      quimioToSave,
      diagToUpdate,
      diagToSave,
      quimioToDelete,
      totalSum: quimioToUpdate.length + quimioToSave.length + diagToUpdate.length + diagToSave.length + quimioToDelete.length
    }
  }

  // verifica se é primeira consulta, sim somente permite se uma conduta tiver sido incluida
  async canSaveMedicalRecord() {
    this.anamnesisService.getAnamnesis.subscribe(anamnesis => {
      console.log(anamnesis)
    }).unsubscribe();
    const questionaries = await firstValueFrom(this.store.select(getMedicalRecordState));
    // const anamnesis = questionaries.anamnesis?.history.length + questionaries.anamnesis
    const { anamnesis, conduct, diagnoses, chemotherapyPage } = questionaries;
    const hasAnamnesis = true;
    const hasconduct = true;
    const allDiagnosisToChange = diagnoses.filter(d => d._changed || d._toSave || d._toUpdate).every(diag => true)

    const isFirstAppointment = this.patientInfoService.isFirstAppointment();
    const firstAppointmentCondition = isFirstAppointment ? (hasAnamnesis && hasconduct) : true;
    const allDetailsValid = chemotherapyPage?.chemotherapy.every(item => item.chemotherapyInformation.prescriptioProgram.some(item => item.detail.length > 0));

    // const canSave = firstAppointmentCondition && allDiagnosisToChange && allDetailsValid
    const canSave = firstAppointmentCondition && allDiagnosisToChange

    return {
      hasAnamnesis,
      hasconduct,
      isFirstAppointment,
      allDiagnosisWithDate: allDiagnosisToChange,
      canSave // se for primeiro atendimento precisa ter os dois, se não não precisa conferir
    }
  }

  async saveAllMedicalRecords(canCloseMedicalRecord: boolean) {
    try {
      this.userLogged && this.userLogged.practitionerId !== '' ?
        await this.diagnosticService.saveAllDiagnosticChanges(this.patientSelectedId, this.userLogged?.practitionerId)
        : '';

      const { quimioToSave, quimioToUpdate, quimioToDelete } = await this.nonQuestionariesMRtoSave()
      const resultQuest = await this.questionnaireService.confirmQuestionnaireDrafts(this.patientSelectedId, this.userLogged?.practitionerId!);
      const resultExamOrders = await this.solicitationService.registerMedicalCare(this.patientSelectedId, this.userLogged?.practitionerId!);
      console.log({ resultExamOrders });

      const diagToSaveRes: any = { status: 'ok' };
      const diagToSaveOk = diagToSaveRes.status === 'ok'
      const diagnosisId = diagToSaveRes?.result?.conditionId ?? '';

      const diagToUpdateOk = true;
      // const diagToUpdateOk = (diagToUpdateRes.length === 0) || diagToUpdateRes.every(dia => dia.status === 'ok')
      // const diagToUptadetatus = diagToUpdateRes
      const questStatus = resultQuest.status

      if (diagnosisId !== '' && quimioToSave.length != 0) {
        const quimioWithDiagnosisId = deepCloning(quimioToSave);
        quimioWithDiagnosisId[0].diagnosisId = diagnosisId;

        const quimioToSaveRes = quimioToSave.length ? await this.chemotherapyService.saveChemotherapy(quimioWithDiagnosisId[0]) : { status: 'ok' }
      } else {
        const quimioToSaveRes = quimioToSave.length ? await this.chemotherapyService.saveChemotherapy(quimioToSave[0]) : { status: 'ok' }
      }

      const quimioToUpdateRes = await Promise.all(quimioToUpdate.map(d => this.chemotherapyService.updateChemotherapy(d)));
      const quimioToDeleteRes = await Promise.all(quimioToDelete.map(d => this.chemotherapyService.deleteChemotherapy(d)))
      // dar um refresh nas info locais do paciente

      await this.onChangeSelectedPatient(this.patientSelectedId, canCloseMedicalRecord)
      await this.patientInfoService.setSelectedPatientById(this.patientSelectedId, { forceRefresh: true })
      return {
        diagToSaveOk,
        questStatus,
        diagToUpdateOk
      }
    } catch (error) {
      console.error({ error })
      throw new Error(error)
    }
  }

  async onChangeSelectedPatient(selectedPatientId: string | null, canCloseMedicalRecord: boolean) {

    try {
      if (canCloseMedicalRecord) {
        await this.closeMedicalRecord();
      }
      if (selectedPatientId === null) {
        this.clearAllMedicalRecord();
        return;
      }
      await this.getAllMedicalRecords(selectedPatientId);
    } catch (error) {
      console.error(error);
    }
  }

  async tryToOpenMedicalRecord() {
    if (!this.userLogged?.practitionerId) {
      throw new Error()
    }
    const result = await this.questionnaireService.checkIfCanEditMedicalRecord(this.patientSelectedId, this.userLogged?.practitionerId);
    if (result.practitionerEditing) {
      const otherUserEditting = result.practitionerEditing.some(x => x.practitionerId !== this.userLogged?.practitionerId)
      if (otherUserEditting) {
        return { opened: false, ...result, otherUserEditting }
      }
    }
    this._isMedicalRecordOpen.next(true)
    return { opened: true, ...result, otherUserEditting: false }
  }

  canEditToday(practitionerName: string, practitionerSpecialty: string): boolean {
    if (this.userLogged && this.userLogged.practitionerId !== '') {
      if (abreviateFullName(this.userLogged.name).toLowerCase() === abreviateFullName(practitionerName.toLowerCase()) &&
        this.userLogged.specialty.toLowerCase() === practitionerSpecialty.toLowerCase()) {
        return true;
      }
      return false;
    }
    return false;
  }

  async closeMedicalRecord() {
    this._isMedicalRecordOpen.next(false)
  }

  get isMedicalRecordOpen() {
    return this._isMedicalRecordOpen.asObservable()
  }

  async getAllQuestionnairesByProfile() {
    try {
      if (this.userLogged) {
        const allOperations = [
          this.anamnesisService.loadAnamnesis(this.patientSelectedId, this.userLogged),
          this.evolutionService.loadEvolution(this.patientSelectedId, this.userLogged),
          this.physicalExamService.loadPhysicalExam(this.patientSelectedId, this.userLogged),
          this.getQuestionnaireResponse('vitalSigns'),
          this.conductService.loadConduct(this.patientSelectedId, this.userLogged),
          this.getQuestionnaireResponse('toxicity'),
          this.nursingService.loadNursing(this.patientSelectedId, this.userLogged),
          this.pharmacyService.loadPharmacy(this.patientSelectedId, this.userLogged),
          this.ramService.loadRAM(this.patientSelectedId, this.userLogged),
          this.nutritionService.loadNutrition(this.patientSelectedId, this.userLogged),
          this.psychologyService.loadPsychology(this.patientSelectedId, this.userLogged),
          this.allergiesComorbsService.loadAllergiesCommorbs(this.patientSelectedId, this.userLogged),
          this.getEducationQuestionnaireResponse()
        ];
        await Promise.allSettled(allOperations);
      }
    }
    catch (error) {
      console.error(error);
      throw error;
    }
  }


  // se nao passar patientId , usa o do paciente atual selecionado
  // obs: patientService usa isso para chamar esse metodo em paralelo com o metodo de get patienteInfo
  getAllMedicalRecords(patientId?: string) {

    this.clearAllMedicalRecord();
    const patId = patientId ?? this.patientSelectedId;
    // this._loadingMedicalRecords.next(true);

    this.loadingMedcialRecordState.set({
      chemotherapy: true,
      diagnoses: true,
      questionaries: true,
      solicitation: true
    })

    return Promise.all([
      this.diagnosticService.getPatientDiagnostics(patId),
      this.getChemotherapyData().finally(() => {
        this.loadingMedcialRecordState.update(state => ({ ...state, chemotherapy: false }))
      }),
      this.getSolicitationData(patId).finally(() => {
        this.loadingMedcialRecordState.update(state => ({ ...state, solicitation: false }))
      }),
      this.getAllQuestionnairesByProfile().finally(() => {
        this.loadingMedcialRecordState.update(state => ({ ...state, questionaries: false }))
      })
    ])

  }

  isLoadingSomeMedicalRecord = computed(() => {
    const state = this.loadingMedcialRecordState();
    return state.chemotherapy || state.diagnoses || state.questionaries || state.solicitation
  })

  isLoadingQuestionaries = computed(() => {
    return (this.loadingMedcialRecordState().questionaries ?? false)
  })

  async getQuestionnaireResponse(name: QuestionaryNames) {
    if (!this.patientSelectedId || !this.userLogged?.practitionerId) {
      console.error('erro! paciente nao selecionado ou nao há dados do usuario ativo')
      return 'notok'
    }
    try {
      const value = await this.questionnaireService.getQuestionnaires(name, this.patientSelectedId, this.userLogged?.practitionerId);
      this.updateMedicalRecordState({ name, value }, 'set');
      return 'ok'
    }
    catch (e) {
      // this.loadingService.hide(typeNameToTabNameMap[ name]);

      console.error(e)
      return 'notok'
    }
  }

  async getEducationQuestionnaireResponse() {
    try {
      if (this.patientSelectedId) {
        let value;
        if (this.userLogged?.practitionerId) {
          value = await this.questionnaireService.getQuestionnaires('education', this.patientSelectedId, this.userLogged?.practitionerId);
        }

        this.store.dispatch(setEducationQuestionnaireResponse({
          education: value as any
        }));
        return 'ok'
      }
      return 'notok'
    }
    catch (e) {

      console.error('Error to get a questionnaire')
      return 'notok'
    } finally {
    }
  }

  async getChemotherapyData() {
    try {
      if (this.patientSelectedId) {
        const chemotherapyResult = await this.chemotherapyService.getSelectedPatientTreatments()
        if (chemotherapyResult.status === 'ok') {
          const chemoterapies = chemotherapyResult.result
          chemoterapies.sort((a, b) => new Date(b?.chemotherapyInformation?.date).getTime() - new Date(a?.chemotherapyInformation?.date).getTime())
          // todo: mover isso para um método proprio
          for (const chemoterapy of chemoterapies) {
            chemoterapy.chemotherapyInformation.prescriptioProgram.sort((a, b) => {
              const cycle = Number(a.cycle) - Number(b.cycle)

              if (cycle !== 0) {
                return cycle
              }

              return Number(a.day) - Number(b.day);
            })
          }

          this.store.dispatch(setChemotherapy({ chemoterapy: chemoterapies }))
        }
      }
    } catch (e) {
      return e;
    }
  }

  async getSolicitationData(patientId?: string) {
    try {
      // this.loadingService.show('requisições');
      const solicitations = await this.solicitationService.getCurrentPatientSolicitations(patientId);
      this.store.dispatch(setSolicitations({ solicitations }));
      // this.loadingService.hide('requisições');
    } catch (error) {

      console.error({ error })
    }
  }

  updateMedicalRecordState({ name, value }: any, method: 'set' | 'clear' | 'update') {

    switch (name) {
      case 'toxicity':
        if (method === 'set') {
          this.store.dispatch(setToxicityQuestionnaireResponse({ toxicityQuestionnaireResponse: value }));
        }
        if (method === 'clear') {
          this.store.dispatch(clearToxicityQuestionnaireResponse());
        }
        if (method === 'update') {
          this.store.dispatch(updateTodayToxicityQuestionnaireResponse({ today: value }));
        }
        break;

      case 'vitalSigns':
        if (method === 'set') {
          this.store.dispatch(setVitalSignsQuestionnaireResponse({ vitalSignsQuestionnaireResponse: value }));
        }
        if (method === 'clear') {
          this.store.dispatch(clearVitalSignsQuestionnaireResponse());
        }
        if (method === 'update') {
          this.store.dispatch(updateTodayVitalSignsQuestionnaireResponse({ today: value }));
        }
        break;
    }
  }

  clearAllMedicalRecord() {
    this.store.dispatch(clearAllMedicalRecord())
  }

  async cancelAllChanges() {
    try {
      await this.closeMedicalRecord()
      await this.questionnaireService.cancelAllDraftRecords(this.patientSelectedId!, this.userLogged?.practitionerId!);
      await this.solicitationService.cancelMedicalCare(this.patientSelectedId, this.userLogged?.practitionerId!);
    } catch (error) {
      console.error(error)
    }
    this.clearAllMedicalRecord()
    // await this.getAllMedicalRecords()
  }

}
